// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sandaconda_gmax: PokeData = {
  "id": 10218,
  "name": "sandaconda-gmax",
  "height": 220,
  "weight": 10000,
  "base_experience": 179,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [],
  "moves": [
    "mud-bomb",
    "mud-slap",
    "magnitude",
    "sandstorm",
    "mud-shot",
    "earth-power",
    "earthquake",
    "fissure"
  ],
  "evolution_chain": {
    "id": 443,
    "item": null,
    "species": [
      {
        "name": "silicobra",
        "order": 843,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sandaconda",
        "order": 844,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 843,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 108,
    "ability_power": 163
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
